import React, { memo } from 'react'
import { Card, Stack } from '@mui/material'

import SubmitButton from '../shared/button/SubmitButton'
import CardHeading from '../shared/text/CardHeading'
import CustomTextField from '../shared/inputs/CustomTextField'
import { REWARDS_PROFILE_DISPATCH } from '../../store/reducers/rewards/rewards'
import brandConfig from 'brandConfig'
import CustomForm from '../shared/inputs/CustomForm'

const ReceiveReward = ({
  t,
  rewardsProfile: { error, rewardCode, loading },
  onQrCodeClick,
  dispatchAction,
  onSubmit,
  symbol
}) => {
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CardHeading
        title={t('home.reward-code')}
        desc={t('home.reward-code-desc', { name: brandConfig.name, symbol })}
      />
      <CustomForm onFormSubmit={onSubmit}>
        <CustomTextField
          qrCodeEnabled
          onQrCodeClick={onQrCodeClick}
          label={t('home.code')}
          error={t(error[REWARDS_PROFILE_DISPATCH.REWARD_CODE])}
          value={rewardCode}
          onChange={(value) =>
            dispatchAction(REWARDS_PROFILE_DISPATCH.REWARD_CODE, value)
          }
          sx={{ mt: 3 }}
        />
        <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
          <SubmitButton label={t('home.receive-reward')} loading={loading} />
        </Stack>
      </CustomForm>
    </Card>
  )
}

export default memo(ReceiveReward)
